import REGEX from "../config/constants/regex";

const validateMobile = (mobile) => REGEX.mobile.test(mobile);
const validateCronJobExpression = (exp) => REGEX.cronJobExp.test(exp);

export { validateMobile, validateCronJobExpression };
